import e from "@dialpad/dialtone-tokens/layered/themes/tokens-inkberry-colors.css?inline";
//#region themes/inkberry.js
var t = {
	brand: {
		css: e,
		name: "inkberry"
	},
	material: { name: "steel" }
};
//#endregion
export { t as default };
